<template>
  <div class="main-content">
    <div
      style="
        width: 100%;
        height: 277px;
        margin: 0;
        padding: 0;
        display: flex;
        justify-content: center;
      "
    >
      <img
        :src="imageUrl"
        alt=""
        style="width: 100%; height: 277px; margin: 0"
      />
    </div>
    <div class="nav">
      <div class="nav-box">
        <div
          v-for="item in navItems"
          :key="item.name"
          @click="selectPage(item.name)"
          :class="{ active: item.name === currentPage }"
        >
          {{ item.label }}
        </div>
      </div>
    </div>
    <div style="width: 1120px; margin: 0 auto; background-color: #fff"></div>
    <div class="content">
      <component
        is="ImageText"
        :ider="ider"
        ref="currentPageComponent"
        v-if="ider"
      ></component>
      <component
        is="SerachInfo"
        :searchValue="searchValue"
        :workId="workId"
        ref="currentPageComponent"
        v-else-if="searchValue"
      ></component>
      <component
        v-else
        :is="currentPage"
        ref="currentPageComponent"
        @changeYm="selectPage"
      ></component>
    </div>
    <div class="bottom-image" style="width: 100%; height: 410px">
      <div class="bottom-text">
        <img src="../../assets/images/bottom-text.png" alt="" />
      </div>
      <div class="connection">
        <div class="left-logo">
          <div class="logo">
            <img src="../../assets/images/logo.png" alt="" />
          </div>
          <div class="text">火焰蓝热线</div>
        </div>
        <div class="right-text">
          <p style="font-weight: 600">支队消防员热线电话：</p>
          <p>{{ objInfo.supportTeamPhone }}</p>
          <p>{{ objInfo.people1 }}</p>
          <p>电话：{{ objInfo.people1Phone }}</p>
          <p>{{ objInfo.people2 }}</p>
          <p>电话：{{ objInfo.people2Phone }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ActiveNews from "./components/ActiveNews.vue";
import BriefingIssue from "./components/BriefingIssue.vue";
import SuperiorSpirit from "./components/SuperiorSpirit.vue";
import Notice from "./components/Notice.vue";
import Information from "./components/Information.vue";
import Model from "./components/Model.vue";
import PartyHistory from "./components/PartyHistory.vue";
import Recommended from "./components/Recommended.vue";
import TypicalStyle from "./components/TypicalStyle.vue";
import PoliticalWork from "./components/PoliticalWork.vue";
import PoliticalRegulations from "./components/PoliticalRegulations.vue";
import ImageText from "./components/ImageText.vue";
import SerachInfo from "./components/SerachInfo.vue";
import { imgList } from "@/api/SpecialWork";
export default {
  data() {
    return {
      navItems: [
        { name: "ActiveNews", label: "首页" },
        { name: "SuperiorSpirit", label: "政工动态" },
        { name: "Notice", label: "上级文件" },
        { name: "Information", label: "通知通报" },
        { name: "TypicalStyle", label: "典型风采" },
        { name: "BriefingIssue", label: "政治教育" },
        { name: "Model", label: "组织建设" },
        { name: "PartyHistory", label: "干部人事" },
        { name: "Recommended", label: "队伍管理" },
        { name: "PoliticalRegulations", label: "政治规定" },
        { name: "PoliticalWork", label: "政工研讨" },
      ],
      currentPage: "ActiveNews", // 默认显示 Home 组件
      workId: 4,
      imageUrl: "",
      ider: "",
      searchValue: "",
      objInfo:{}
    };
  },
  created() {
    if (this.$route.query.param) {
      this.workId = JSON.parse(this.$route.query.param);
      console.log(this.$route.query.param, "this.$route.query.param");
    }
    if (this.$route.query.ider) {
      this.ider = JSON.parse(this.$route.query.ider);
      console.log(this.$route.query.ider, "this.$route.query.ider");
      this.currentPage = "";
    }
    if (this.$route.query.searchValue) {
      this.searchValue = this.$route.query.searchValue;
      console.log(
        this.$route.query.searchValue,
        "this.$route.query.searchValue"
      );
      this.currentPage = "";
    }
    this.getImgList();
  },
  methods: {
    getImgList() {
      const query = {
        pageNum: 1,
        pageSize: 10,
      };
      imgList(query).then((res) => {
        if (res.data.code === 200) {
          console.log(res.data.data.list);
          this.objInfo = res.data.data.list[0];
          const list = res.data.data.list;
          console.log(this.objInfo , "image");
          list.forEach((item) => {
            if (item.id === this.workId) {
              this.imageUrl = item.image;
              document.title = item.name;
              console.log(item.image, "image", this.imageUrl);
            }
          });
        }
      });
    },
    selectPage(page) {
      this.currentPage = page; // 切换当前页面
      this.ider = "";
      this.searchValue = "";
      if (page === "ActiveNews" && this.$refs.currentPageComponent.setShow) {
        this.$refs.currentPageComponent.setShow(true);
      }
    },
  },
  components: {
    ActiveNews,
    SuperiorSpirit,
    Notice,
    Information,
    BriefingIssue,
    Model,
    PartyHistory,
    Recommended,
    TypicalStyle,
    PoliticalWork,
    PoliticalRegulations,
    ImageText,
    SerachInfo,
  },
};
</script>

<style scoped lang="scss">
.main-content {
  min-height: 100vh;
  background-color: #f0f5ff;
}
.navbar {
  display: flex;
  background-color: #f8f8f8;
  padding: 10px;
}

.nav {
  width: 100%;
  height: 38px;
  margin: 0 auto;
  background: linear-gradient(to bottom, #144ea0, #165280);

  .nav-box {
    width: 1120px;
    height: 38px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 auto;

    div {
      width: 92px;
      height: 38px;
      font-weight: bold;
      font-size: 16px;
      color: #fff;
      cursor: pointer;
      text-align: center;
      line-height: 38px;
    }

    .active {
      background-color: #0d4673;
    }
  }
}

.nav-item {
  margin: 0 15px;
  cursor: pointer;
  padding: 5px 10px;
  border-radius: 5px;
  transition: background-color 0.3s;
}

.nav-item:hover {
  background-color: #e0e0e0;
}
.bottom-image {
  background-image: url("../../assets/images/bottom-banner.png");
  background-size: cover;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .bottom-text {
    width: 532px;
    height: 46px;
    margin-bottom: 40px;
  }
  .connection {
    display: flex;
    width: 355px;
    height: 194px;
    padding-left: 12px;
    margin-bottom: 90px;
    background-color: #2b56ac;
    border-radius: 8px;
    .left-logo {
      width: 143px;
      height: 170px;
      margin-top: 12px;
      background-color: #ffffff;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      border-radius: 8px;
      .logo {
        margin-bottom: 10px;
      }
      .text {
        margin-bottom: 20px;
        color: #2b56ac;
        font-weight: 600;
      }
    }
    .right-text {
      margin-left: 30px;
      width: 150px;
      font-size: 14px;
      line-height: 15px;
      font-weight: 500;
      color: #ffffff;
    }
  }
}
</style>
